import React from "react";
import { Helmet } from "react-helmet";
import { Mail } from "lucide-react";
import LegalShell from "./LegalShell";

const ACCENT = "#F5A623";
const SUPPORT_EMAIL = "support@pagent.tv";

export default function Support() {
  return (
    <LegalShell
      title="Support"
      subtitle="Questions about the app, your account, or a contest"
    >
      <Helmet>
        <title>Support - Pagent</title>
        <meta
          name="description"
          content="Contact Pagent support at support@pagent.tv for questions about your account, the app, or contests."
        />
        <link rel="canonical" href="https://www.pagent.tv/support" />
      </Helmet>

      <div className="rounded-2xl border border-white/10 bg-zinc-900/60 px-6 py-12 text-center sm:px-12">
        <Mail className="mx-auto h-12 w-12 text-yellow-400" />
        <h2 className="mt-6 text-2xl font-bold text-white">Email us</h2>
        <p className="mx-auto mt-3 max-w-md leading-relaxed text-zinc-300">
          Send inquiries to our support team. Include your username and a short
          description of what you need help with.
        </p>
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          className="mt-8 inline-flex items-center gap-2 rounded-full px-6 py-3 text-base font-semibold text-black transition-opacity hover:opacity-90"
          style={{ backgroundColor: ACCENT }}
        >
          <Mail className="h-4 w-4" />
          {SUPPORT_EMAIL}
        </a>
      </div>
    </LegalShell>
  );
}
